<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation class="bg-gray-900 dark print:hidden flex flex-col border-r" [mode]="isScreenSmall ? 'over' : 'side'"
  [appearance]="isScreenSmall ? 'default' : (menuState === 1 ? 'dense' : 'default')"
  [name]="'mainNavigation'" [navigation]="currentNavigationItems" [opened]="isScreenSmall ? false : (menuState !== 2)"
  (mouseenter)="onNavMouseEnter()" (mouseleave)="onNavMouseLeave()">
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <!-- Fixed header section -->
    <div class="flex-shrink-0">
      <div class="flex items-center w-full p-4 pl-6">
        <!-- Logo -->
        <div class="flex items-center justify-center p-4">
          <img class="w-4" src="./assets/logo/Icon-TERA-color-light.png" alt="logo TERA" />
          <!-- Environment badge (non-prod only) -->
          <div *ngIf="!environment.production" class="mx-2 px-1 border border-dashed rounded text-xs text-center">
            <ng-container *ngIf="environment.GATEWAY_API?.includes('localhost')">local&nbsp;</ng-container>
            <ng-container *ngIf="!environment.GATEWAY_API?.includes('localhost') && (environment.environmentName === 'dev' || environment.GATEWAY_API?.includes('dev'))">dev</ng-container>
            <ng-container *ngIf="environment.environmentName === 'rec' || environment.GATEWAY_API?.includes('recette')">recette</ng-container>
            <ng-container *ngIf="environment.environmentName === 'uat' || environment.GATEWAY_API?.includes('uat')">uat</ng-container>
            <ng-container *ngIf="environment.environmentName === 'demo' || environment.GATEWAY_API?.includes('demo')">démo</ng-container>
            <ng-container *ngIf="environment.environmentName === 'preprod' || environment.GATEWAY_API?.includes('preprod')">preprod</ng-container>
          </div>

        </div>
        <!-- Components -->
        <div class="flex items-center ml-auto">
          <user [showAvatar]="true"></user>
        </div>
      </div>
      <!-- User -->
      <div class="flex flex-col items-center w-full pt-1 pb-3">
        <div class="relative w-24 h-24 hidden">
          <img class="w-full h-full rounded-full" *ngIf="connectedUser?.avatar" [src]="connectedUser?.avatar"
            alt="User avatar" />
          <mat-icon class="icon-size-24" *ngIf="!connectedUser?.avatar"
            [svgIcon]="'heroicons_solid:user-circle'"></mat-icon>
        </div>
        <div class="flex flex-col items-center justify-center w-full mb-2">
          <div *ngIf="isScreenSmall || menuState !== 1 || isNavHover" class="w-full overflow-hidden font-medium leading-normal text-center whitespace-nowrap text-ellipsis">
            {{ connectedUser?.firstName }} {{ connectedUser?.name }}
          </div>
          <div *ngIf="!isScreenSmall && menuState === 1 && !isNavHover" class="w-full overflow-hidden font-medium leading-normal text-center whitespace-nowrap text-ellipsis">
            {{ ((connectedUser?.firstName?.slice(0,1) || '') + (connectedUser?.name?.slice(1,2) || '')) | uppercase }}
          </div>
          <div *ngIf="isScreenSmall || menuState !== 1 || isNavHover" class="w-full mt-0.5 whitespace-nowrap text-ellipsis overflow-hidden text-center text-md leading-normal font-medium text-secondary">
            {{ connectedUser?.email }}
          </div>
        </div>
      </div>

      
      <!-- Search box - Fixed position -->
      <div class="px-4 py-2 mb-4 border-b border-default" style="margin-top:0.5px">
        <div class="relative">
          <input type="text" placeholder="Rechercher dans le menu..."
            class="search-input w-full px-3 py-2 text-sm rounded-md text-white placeholder-accent-300 bg-gray-800 focus:bg-gray-700 focus:outline-none transition-colors duration-200"
            [(ngModel)]="searchQuery" (input)="onSearchQueryChange($event)" />
          <button *ngIf="searchQuery"
            class="absolute right-2 top-1/2 transform rounded-full -translate-y-1/2 bg-primary-600 text-white hover:text-gray-300 transition-colors"
            (click)="clearSearch()">
            <mat-icon class="text-sm">close</mat-icon>
          </button>
        </div>
        <div *ngIf="searchQuery" class="search-results-info mt-2 text-xs text-gray-400">
          Resultats filtres par "{{ searchQuery }}"
        </div>
      </div>
    </div>

    <settings></settings>
  </ng-container>
  <!-- Navigation footer hook -->
  <ng-container fuseVerticalNavigationFooter>
    <div class="flex items-center justify-center h-16 pl-2 pr-6 mb-4 flex-0 opacity-50">
      <img class="max-w-36" src="assets/logo/Logo-TERA-light.png" alt="logo TERA" />
    </div>
  </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
  <!-- Header -->
  <div
    class="relative flex items-center w-full h-16 px-4 shadow flex-0 md:px-6 z-49 dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
    <!-- Navigation toggle button -->
    <button mat-icon-button class="flex items-center" (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
    </button>
    <!-- Components -->
    <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
      <languages *ngIf="false"></languages>
      <fuse-fullscreen class="hidden md:block absolute left-1/2 -translate-x-1/2 z-20 w-[40rem] max-w-[58vw] lg:w-full lg:max-w-full pointer-events-none"></fuse-fullscreen>
      <search [appearance]="'bar'"></search>
      <shortcuts *ngIf="false"></shortcuts>
      <messages *ngIf="false"></messages>
      <notifications *ngIf="false"></notifications>
      <button class="lg:hidden" mat-icon-button *ngIf="false">
        <!--(click)=quickCaht.toggle()-->
        <mat-icon [svgIcon]="'heroicons_outline:chat-alt-2'"></mat-icon>
      </button>
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-col flex-auto">
    <!-- *ngIf hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    <router-outlet *ngIf="true"></router-outlet>
  </div>

  <!-- Footer -->
</div>

<!-- Quick chat -->
<quick-chat #quickChat="quickChat" *ngIf="false"></quick-chat>
